import { actions } from "./actions";
import { mutations } from "./mutations";
import { state } from "./state";

export const authenticationLogs = {
  state,
  mutations,
  actions
};
